/* eslint-disable @typescript-eslint/prefer-function-type */
/* eslint-disable @typescript-eslint/no-misused-new */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useEffect, useState, useRef } from "react";
import { renderToString } from "react-dom/server";
import { Container as MapDiv, NaverMap, useNavermaps } from "react-naver-maps";
import GraphicFaceYellow from "@public/Assets/Icons/GraphicBlueHeart.svg";
import GraphicFaceGray from "@public/Assets/Icons/DogFaceGray.svg";
import GraphicFaceRed from "@public/Assets/Icons/DogFaceRed.svg";
import DogPoop from "@public/Assets/Icons/SimplePoop.svg";

import Image, { type StaticImageData } from "next/image";
import { PetImageAtom } from "~/components/Atoms/PetImageAtom/PetImageAtom";
import { MapPinPointAtom } from "~/components/Atoms/MapPinPointAtom/MapPinPointAtom";
import { MapDirection, Marker } from "./components";
import { MapButton } from "~/components/Atoms/MapButton/MapButton";
import type { MapsComponentporps } from "./types";

function MapComponent({
  clusterMarkers,
  categories,
  direction,
  myPets,
  nearByPets,
  poops,
  NaverMapProps,
  myLocation,
  setMap: UserMapSet,
  ...props
}: MapsComponentporps) {
  const navermaps = useNavermaps();
  const [map, setMap] = useState<naver.maps.Map>();
  const clusterRef = useRef<any>(null);

  useEffect(() => {
    if (UserMapSet && map) {
      UserMapSet(map);
    }
  }, [UserMapSet, map]);

  // useEffect(() => {
  //   if (nearByPets && !clusterRef.current) {
  //     void import("./cluster").then(({ MarkerClustering }) => {
  //       // NOTE: 'naver is not defined' 오류를 피하기 위한 hack 코드. 빠른 답변을 위해 대충 dynamic import를 사용했습니다..!
  //       const htmlMarker1 = {
  //           content: [
  //             `<div style='width: 40px; height: 40px; border-radius: 50%;  background: #b08fc5;
  //                          display: flex; align-items: center; justify-content: center'>`,
  //             `<span style='color: white; font-size: 0.875rem'>1</span>`,
  //             `</div>`,
  //           ].join(""),
  //           size: new naver.maps.Size(40, 40),
  //           anchor: new naver.maps.Point(20, 20),
  //         },
  //         htmlMarker2 = {
  //           content: [
  //             `<div style='width: 40px; height: 40px; border-radius: 50%;  background: #cdbdd7;
  //                          display: flex; align-items: center; justify-content: center'>`,
  //             `<span style='color: white; font-size: 0.875rem'>2</span>`,
  //             `</div>`,
  //           ].join(""),
  //           size: new naver.maps.Size(40, 40),
  //           anchor: new naver.maps.Point(20, 20),
  //         };
  //       // Update state with new markers

  //       clusterRef.current = new MarkerClustering({
  //         minClusterSize: 2,
  //         maxZoom: 15,
  //         map: map,
  //         markers: nearByPets?.map(
  //           (pet) =>
  //             new naver.maps.Marker({
  //               map: map,
  //               position: new naver.maps.LatLng({
  //                 lat: pet.coordinates.lat,
  //                 lng: pet.coordinates.long,
  //               }),
  //               icon: {
  //                 size: new naver.maps.Size(60, 60),
  //                 anchor: new naver.maps.Point(30, 30),
  //                 content: renderToString(
  //                   <MapPinPointAtom
  //                     image={GraphicFaceYellow as StaticImageData}
  //                     type="CyanLocation"
  //                   />,
  //                 ),
  //               },
  //             }),
  //         ),
  //         disableClickZoom: false,
  //         gridSize: 120,
  //         icons: [htmlMarker1, htmlMarker2],
  //         indexGenerator: [10, 100, 200, 500, 1000],
  //         stylingFunction: function (clusterMarker: any, count: number) {
  //           // NOTE: MarkerClustering.js가 자바스크립트라 임시로 any 적용
  //           clusterMarker.getElement().querySelector("span").textContent =
  //             count;
  //           clusterMarker.setZIndex(200);
  //         },
  //       });
  //     });
  //   }

  //   return () => {
  //     if (clusterRef.current) {
  //       clusterRef.current.clear();
  //       clusterRef.current = null;
  //     }
  //   };
  // }, [nearByPets, clusterRef.current]);

  return (
    <>
      <MapDiv
        className={`relative h-full min-h-[702px] w-full min-w-[375px] overflow-hidden ${
          props?.className ?? ""
        } `}
        {...(props ?? {})}
      >
        <NaverMap
          {...{
            zoom: 17,
            // ...(NaverMapProps ?? {}),
            // // center: new naverMaps.LatLng(
            // //   (NaverMapProps as unknown as MapsComponentporps["NaverMapProps"])
            // //     ?.center?.lat ?? 36.2253017,
            // //   (NaverMapProps as unknown as MapsComponentporps["NaverMapProps"])
            // //     ?.center?.long ?? 127.6460516,
            // // ),
            // center: new naverMaps.LatLng(
            //   myLocation?.coordinates.lat ?? 0,
            //   myLocation?.coordinates.long ?? 0,
            // ),
          }}
          /*
           * Reference of the Map will be stored in setMap
           */
          ref={setMap as any}
        >
          {/* Direciton / Route For Dog Walk */}
          {direction ? <MapDirection {...direction} /> : null}
          {/* Cluster Group Markers */}
          {clusterMarkers
            ? clusterMarkers.map((el) => (
                <Marker
                  key={JSON.stringify(el.coordinates.lat)}
                  {...el}
                  icon={{
                    size: new naver.maps.Size(60, 60),
                    anchor: new naver.maps.Point(30, 30),
                    content: renderToString(
                      <MapPinPointAtom
                        number={el.numberOfPets}
                        type="NumberLocation"
                      />,
                    ),
                  }}
                />
              ))
            : null}
          {/* NearBy Pets Array */}
          {nearByPets
            ? nearByPets.map((el) => {
                let index = 0;
                let anchor = 0;

                const thirtySecondsAgo = new Date(
                  new Date().getTime() - 30 * 1000,
                );

                const twelveHoursAgo = new Date(
                  new Date().getTime() - 12 * 60 * 60 * 1000,
                );

                const sameLocationPets = nearByPets.filter((pet: any) => {
                  return (
                    pet.coordinates.lat === el.coordinates.lat &&
                    pet.coordinates.long === el.coordinates.long
                  );
                });

                const sameLocationCount = sameLocationPets.length;

                if (sameLocationCount > 1) {
                  index = sameLocationPets.findIndex((pet) => pet.id === el.id);
                }

                if (sameLocationCount === 2) {
                  if (index === 0) {
                    anchor = 8;
                  } else if (index === 1) {
                    anchor = -8;
                  }
                }

                if (sameLocationCount === 3) {
                  if (index === 0) {
                    anchor = 16;
                  } else if (index === 2) {
                    anchor = -16;
                  }
                }

                if (sameLocationCount === 4) {
                  if (index === 0) {
                    anchor = 24;
                  } else if (index === 1) {
                    anchor = 8;
                  } else if (index === 2) {
                    anchor = -8;
                  } else if (index === 3) {
                    anchor = -24;
                  }
                }

                return (
                  <Marker
                    zIndex={el.image ? 100 : sameLocationCount > 4 ? 50 : 10}
                    key={el.id}
                    {...el}
                    icon={{
                      size: new naver.maps.Size(60, 60),
                      anchor: new naver.maps.Point(30 + anchor, 30),
                      content: renderToString(
                        el.image && el.lastLocationAt > thirtySecondsAgo ? (
                          <PetImageAtom
                            type="DogRound"
                            showBorder={false}
                            image={el.image}
                            className={`h-[50px] w-[50px]`}
                            imageClassName={`h-[50px] w-[50px]`}
                          />
                        ) : el.isMissingPet ? (
                          <MapPinPointAtom
                            type="RedLocation"
                            image={GraphicFaceRed as StaticImageData}
                          />
                        ) : sameLocationCount > 4 ? (
                          <MapPinPointAtom
                            type="NumberLocation"
                            number={sameLocationCount}
                          />
                        ) : el.lastLocationAt < thirtySecondsAgo &&
                          el.lastLocationAt > twelveHoursAgo ? (
                          <MapPinPointAtom
                            image={GraphicFaceGray as StaticImageData}
                            type="GrayLocation"
                          />
                        ) : (
                          <MapPinPointAtom
                            image={GraphicFaceYellow as StaticImageData}
                            type="CyanLocation"
                          />
                        ),
                      ),
                    }}
                  />
                );
              })
            : null}
          {/* Categories Array */}
          {categories
            ? categories.map((el) => (
                <Marker
                  key={el.coordinates.lat}
                  {...el}
                  icon={{
                    size: new naver.maps.Size(32, 36),
                    anchor: new naver.maps.Point(16, 18),
                    content: renderToString(
                      <MapButton
                        icon={el.icon}
                        color={el.color ?? "bg-SunriseYellow-4"}
                      />,
                    ),
                  }}
                />
              ))
            : null}
          {/* Owner's Pets Array */}
          {myPets
            ? myPets.map((el) => {
                const imageSize = 50;
                let anchor = 0;

                if (el.total > 1) {
                  anchor =
                    el.index === 0
                      ? imageSize / 2
                      : el.index === 1
                        ? 0
                        : -imageSize / 2;
                }

                return (
                  <Marker
                    zIndex={200}
                    key={el.id}
                    {...el}
                    icon={{
                      anchor: new naver.maps.Point(
                        imageSize / 2 + anchor,
                        imageSize / 2,
                      ),
                      content: renderToString(
                        <PetImageAtom
                          type="DogWithBorder"
                          showBorder
                          image={el.image}
                          className={`h-[50px] w-[50px]`}
                          imageClassName={`h-[40px] w-[40px]`}
                        />,
                      ),
                    }}
                  />
                );
              })
            : null}
          {/* Poops Array */}
          {poops
            ? poops.map((el) => (
                <Marker
                  key={el.coordinates.lat}
                  {...el}
                  icon={{
                    size: new naver.maps.Size(24, 24),
                    anchor: new naver.maps.Point(12, 12),
                    content: renderToString(
                      <Image
                        height={24}
                        width={24}
                        src={DogPoop as string}
                        alt="dog"
                      />,
                    ),
                  }}
                />
              ))
            : null}
          {myLocation ? (
            <Marker
              zIndex={100}
              key="me"
              {...myLocation}
              icon={{
                size: new naver.maps.Size(24, 24),
                anchor: new naver.maps.Point(16, 16),
                content: renderToString(<MapPinPointAtom type="Circle" />),
              }}
            />
          ) : null}
        </NaverMap>
      </MapDiv>
    </>
  );
}

export default MapComponent;
